export function ScrollAnimationIcon() {
  return (
    <svg
      width="35"
      height="166"
      viewBox="0 0 35 166"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="flr Scroll Icon">
        <g id="ubh Frame 7">
          <g id="Scroll Iine" clipPath="url(#clip0_50_3332)">
            <g id="Frame 2085660891">
              <path
                id="Vector 1"
                d="M17.5 70.5L17.5 170.5"
                stroke="white"
                className="animate-scroll-line"
              />
            </g>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_50_3332">
          <rect
            width="12"
            height="116"
            fill="white"
            transform="translate(11.5 61.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
